import { Component, ComponentRef, HostBinding, ViewChild, ViewContainerRef } from "@angular/core";
import { RootContainerOverlayService } from "@skylab-angular-shared/scenes";
import { Constructor } from "@skylab-shared/types";

@Component({
    selector: 'skl-app-loading-overlay',
    templateUrl: './app-loading-overlay.component.html',
    styleUrls: ['./app-loading-overlay.component.scss']
})
export class AppLoadingOverlayComponent {
    public customText = '';
    public componentRef: ComponentRef<any>;
    @ViewChild('customComponent', { read: ViewContainerRef }) public viewContainerRef: ViewContainerRef;
    @HostBinding('style.display') public display = 'none';

    public constructor(
        protected readonly overlayService: RootContainerOverlayService
    ) { }

    public ngAfterViewInit(): void {
        this.overlayService.visibilityStatus$.subscribe(options => {
            if (!options) {
                this.display = 'none';
                this.destroyCustomComponent();
                return;
            }

            this.display = 'block';
            this.customText = options.text || '';

            if (options.component) {
                this.createCustomComponent(options.component);
            }
        });
    }

    private createCustomComponent(component: Constructor<unknown>): void {
        this.componentRef = this.viewContainerRef.createComponent(component);
    }

    private destroyCustomComponent(): void {
        this.viewContainerRef?.detach();
        this.componentRef?.destroy();
        this.componentRef === null;
    }
}
